import { uniqBy } from 'lodash';

import * as types from './constants';

const initialState = {
  results: [],
  count: 0,
  next: null,
  loaded: false,
  loading: false,
  loadMoreLoading: false,
  createLoading: false,
  updateLoading: false,
  removeLoading: false,
  errors_api: {}
};

const actions = {
  // Get Creator Notes
  [types.GET_CREATOR_NOTES_REQUEST]: state => {
    const data = {
      ...state,
      ...initialState,
      loading: true
    };

    return { ...data };
  },

  [types.GET_CREATOR_NOTES_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      ...payload,
      loaded: true,
      loading: false
    };

    return { ...data };
  },

  [types.GET_CREATOR_NOTES_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Load More Creator Notes
  [types.LOAD_MORE_CREATOR_NOTES_REQUEST]: state => {
    const data = {
      ...state,
      loadMoreLoading: true
    };

    return { ...data };
  },

  // A note created since the first page shifts the pages by one, so the next page can repeat a loaded note
  [types.LOAD_MORE_CREATOR_NOTES_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      results: uniqBy([...state.results, ...payload.results], 'id'),
      count: payload.count,
      next: payload.next,
      loadMoreLoading: false
    };

    return { ...data };
  },

  [types.LOAD_MORE_CREATOR_NOTES_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loadMoreLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Create Creator Note
  [types.CREATE_CREATOR_NOTE_REQUEST]: state => {
    const data = {
      ...state,
      createLoading: true,
      errors_api: {}
    };

    return { ...data };
  },

  [types.CREATE_CREATOR_NOTE_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      results: [payload, ...state.results],
      count: state.count + 1,
      createLoading: false
    };

    return { ...data };
  },

  [types.CREATE_CREATOR_NOTE_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      createLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Update Creator Note
  [types.UPDATE_CREATOR_NOTE_REQUEST]: state => {
    const data = {
      ...state,
      updateLoading: true,
      errors_api: {}
    };

    return { ...data };
  },

  [types.UPDATE_CREATOR_NOTE_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      results: state.results.map(note => note.id === payload.id ? payload : note),
      updateLoading: false
    };

    return { ...data };
  },

  [types.UPDATE_CREATOR_NOTE_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      updateLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Remove Creator Note
  [types.REMOVE_CREATOR_NOTE_REQUEST]: state => {
    const data = {
      ...state,
      removeLoading: true
    };

    return { ...data };
  },

  [types.REMOVE_CREATOR_NOTE_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      results: state.results.filter(note => note.id !== payload),
      count: Math.max(state.count - 1, 0),
      removeLoading: false
    };

    return { ...data };
  },

  [types.REMOVE_CREATOR_NOTE_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      removeLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.CREATOR_NOTES_RESET]: () => {
    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
